import { withClientLabel } from "src/app/common/client-label";
import { Component, ElementRef, OnInit, PLATFORM_ID, inject, viewChild, signal, ViewEncapsulation } from "@angular/core";
import { BillingsService } from "../../services/billings.service";
import { Validators, FormBuilder, FormGroup, FormArray, FormControl, FormsModule, ReactiveFormsModule, AbstractControl } from "@angular/forms";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";

import { Blog } from "../../models/blog";
import { Category } from "../../models/category";
import { ConfirmationService, MessageService, SelectItem, PrimeTemplate } from "primeng/api";
import {
  BILLING_LIST,
  PARAM_BILLINGS_PATH,
  TYPE_LIST,
} from "../../constants/constants";
import { Clients } from "src/app/models/clients";
import { ClientsService } from "src/app/services/clients.service";
import { Locations } from "src/app/models/locations";
import { Bookings } from "src/app/models/bookings";
import { BookingsService } from "src/app/services/bookings.service";
import { CompanyService } from "src/app/services/company.service";
import { Company } from "src/app/models/company";
import { Billings } from "src/app/models/billings";
import { Skills } from "src/app/models/skills";
import { AbstractFormComponent } from "../../common/abstract-edit.component";
import { Observable, of } from "rxjs";
import { PdfEngineService } from "src/app/pdf/pdf-engine.service";
import { invoiceTemplate } from "src/app/pdf/templates/invoice.template";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Card } from "primeng/card";
import { SelectButton } from "primeng/selectbutton";
import { InputText } from "primeng/inputtext";
import { DatePicker } from "primeng/datepicker";
import { AutoComplete } from "primeng/autocomplete";
import { Select } from "primeng/select";
import { Textarea } from "primeng/textarea";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { Tag } from "primeng/tag";
import { CdkDropList, CdkDrag } from "@angular/cdk/drag-drop";
import { InputNumber } from "primeng/inputnumber";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-billings-form",
    templateUrl: "./billings-form.component.html",
    styleUrl: "./billings-form.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Card, SelectButton, InputText, DatePicker, AutoComplete, PrimeTemplate, Select, Textarea, Tag, CdkDropList, CdkDrag, InputNumber, Toast, CurrencyPipe, DatePipe, TranslatePipe]
})
export class BillingsFormComponent
  extends AbstractFormComponent<Billings>
  implements OnInit
{
  protected fb: FormBuilder;
  private billingsService = inject(BillingsService);
  private clientsService = inject(ClientsService);
  private bookingsService = inject(BookingsService);
  private pdfEngine = inject(PdfEngineService);
  private companyService = inject(CompanyService);
  private platformId = inject(PLATFORM_ID);

  readonly myInputVariable = viewChild<ElementRef>("myInput");
  pageTitle: string;
  error: string;
  form: FormGroup;
  uploadError: string;
  readonly companyList = signal<Company[]>([]);
  readonly selectedCompany = signal<Company | null>(null);
  item$: Observable<Billings> = of();
  service = this.billingsService;
  idField = "id";
  formFields = [
    "id",
    "title",
    "description",
    "appointment_id",
    "client_id",
    "company_id",
    "is_featured",
    "date",
    "user_id",
    "number",
    "skills",
    "subtotal",
    "vat",
    "total",
    "is_paid",
  ];

  itemTotal: any;
  bookings: Bookings;
  booking: Bookings;
  billing: Billings;
  billings: Billings;
  categories: any = [];
  category: Category;
  checked: boolean = true;
  selectedValue: string;
  clients: any = [];
  client: Clients;
  skillsArray: any = [];
  description: any;
  selectedWorks: SelectItem[] = [];
  selectedWorks2: SelectItem[];
  locations: any = [];
  location: Locations;
  readonly element = signal<Billings>(undefined);

  readonly subTotal = signal<any>(undefined);
  readonly vat = signal<any>(undefined);
  readonly grandTotal = signal<any>(undefined);
  is_paid: string;
  id: string;
  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedCategories: Category;
  selectedClients: Clients;
  selectedDate: Date;
  date: Date;
  readonly page = signal<string>(undefined);
  idBookings: number;
  readonly idBilling = signal<number>(undefined);
  readonly categoryBookings = signal<string>(undefined);
  works_idBookings: any;
  company: any[];
  readonly descriptionBillings = signal<string>(undefined);
  readonly dateBookings = signal<string>(undefined);
  numberBookings: number;
  numberOrders: number;
  currentUser: any;
  public dataValues: object;
  readonly skillsValues = signal<any>([]);
  total: number;
  viewMode = "1";
  readonly editForm = signal<boolean>(true);
  company_tax: any;
  address: string;
  email: string;
  rooms: Skills[] = [];
  additionalDetails: string;
  readonly selectedClient = signal<any | null>(null);
  readonly filteredClients = signal<any[]>([]);
  readonly selectedClientData = signal<Clients | null>(null);
  typeList = TYPE_LIST;
  billingOptions = BILLING_LIST;
  constructor() {
    const fb = inject(FormBuilder);
    const messageService = inject(MessageService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      fb,
      messageService,
      confirmationService,
      router,
      route,
      PARAM_BILLINGS_PATH,
    );

    this.fb = fb;
  }

  readonly reportContent = viewChild<ElementRef>("reportContent");

  ngOnInit() {
    this.initializeForm();
    this.getCompany();
    this.page.set(history.state);

    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Modifica Fattura";
      this.loadItem(id);
    } else {
      this.pageTitle = "Aggiungi Fattura";
      this.editForm.set(false);
      const today = new Date().toISOString().slice(0, 10);
      this.form.patchValue({ date: today });
      this.dateBookings.set(today);
      this.loadNextNumber();
    }
  }

  readonly numberEdited = signal(false);
  readonly numberHint = signal("");

  private loadNextNumber(): void {
    if (this.route.snapshot.paramMap.get("id") || this.numberEdited()) return;
    const year = Number(String(this.form.get("date")?.value || "").slice(0, 4)) || new Date().getFullYear();
    this.billingsService.nextNumber(year).subscribe({
      next: (r) => {
        this.form.patchValue({ number: String(r.number) });
        this.idBilling.set(r.number);
        this.numberHint.set(`Progressivo ${r.year}: l'ultima fattura dell'anno + 1`);
      },
      error: () => this.numberHint.set(""),
    });
  }

  getSelectedClient(): Clients | undefined {
    const id = this.form.get("client_id")?.value;
    if (!id) return undefined;
    return this.clients?.find((c: any) => String(c.id) === String(id));
  }

  getCompany() {
    const companyParam = {};
    this.companyService.list(companyParam).subscribe((res) => {
      this.companyList.set(res);

      const companyId = this.form.get("company_id")?.value;
      if (companyId) this.onCompanyChange(companyId);
    });
  }

  loadItem(id: string) {
    this.service.getId(id).subscribe(
      (res: any) => {
        this.element.set(res);
        this.idBilling.set(res.number);
        this.categoryBookings.set(res.client_id);
        this.descriptionBillings.set(res.description);
        this.dateBookings.set(res.date);

        this.form.patchValue({
          title: res.title,
          description: res.description,
          client_id: res.client_id,
          company_id: res.company_id,
          appointment_id: res.appointment_id,
          is_featured: res.is_featured,
          date: res.date,
          id: res.id,
          subtotal: res.subtotal,
          vat: res.vat,
          number: res.number,
          is_paid: res.is_paid,
          total: res.total,
        });

        this.setSkillsFormArray(res.skills);

        if (res.company_id) {
          this.selectedCompany.set(this.companyList().find((c) => c.id === res.company_id) || null);
        }

        if (res.client_id) {
          this.clientsService.getId(res.client_id).subscribe(
            (client) => {
              this.selectedClient.set(withClientLabel(client));
              this.selectedClientData.set(client);
              this.loadClientBookings(client.id);
            },
            (error) => (this.error = error),
          );
        } else {
          this.selectedClient.set(null);
          this.selectedClientData.set(null);
        }
      },
      (error) => (this.error = error),
    );
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      title: [""],
      description: [""],
      appointment_id: [""],
      client_id: [""],
      company_id: [""],
      works_id: [""],
      is_featured: ["0"],
      date: ["", Validators.required],
      skills: this.initSkill(),
      subtotal: [""],
      is_paid: [""],
      vat: [""],
      number: [""],
      total: [this.grandTotal()],
    });
  }

  onCompanyChange(companyId: string) {
    if (!companyId) {
      this.selectedCompany.set(null);
      return;
    }

    this.selectedCompany.set(this.companyList().find((c) => c.id === companyId) || null);

    this.itemsChanged();
  }

  changed(value) {
    this.descriptionBillings.set(value.target.value);
  }

  changedNumber(value) {
    this.numberEdited.set(true);
    this.idBilling.set(value.target.value);
  }

  generatePDF(action: "download" | "print" = "download") {
    const payload = {
      company: this.selectedCompany(),
      client: this.selectedClientData(),
      skills: this.mapSkillsForPdf(),
      number: this.form.get("number")?.value,
      date: this.form.get("date")?.value,
      description: this.form.get("description")?.value,
      paid: String(this.form.get("is_paid")?.value) === "1",
      subtotal: this.subTotal(),
      vat: this.vat(),
      total: this.grandTotal(),
    };

    const doc = invoiceTemplate(payload);

    this.pdfEngine.create(doc, action, "fattura.pdf");
  }

  changeTime(value) {
    this.dateBookings.set(value.target.value);
    this.loadNextNumber();                 // another year starts another sequence
  }

  getCategoryItem = (categoryBookings: string, id: string) =>
    this.clients?.find(({ id }) => id === categoryBookings);

  editFormItems() {
    this.editForm.set(!this.editForm());
  }

  itemsChanged(): void {
    const skills = this.form.get("skills") as FormArray;
    if (!skills) return;

    const subTotal = skills.controls.reduce((sum, ctrl) => {
      const price = Number((ctrl as FormGroup).get("price")?.value ?? 0);
      return sum + (isNaN(price) ? 0 : price);
    }, 0);

    const fiscaltype = Number(this.selectedCompany()?.fiscaltype ?? 0);
    const vat = (subTotal * fiscaltype) / 100;
    const grandTotal = subTotal + vat;

    this.subTotal.set(subTotal);
    this.vat.set(vat);
    this.grandTotal.set(grandTotal);

    this.form.patchValue(
      {
        subtotal: subTotal,
        vat: vat,
        total: grandTotal,
      },
      { emitEvent: false },
    );
  }

  closeBilling() {
    const formData = new FormData();

    formData.set("is_paid", "0");

    const id = this.form.get("id").value;

    this.billingsService.update(formData, id).subscribe(
      (res) => {
        if (res.status == "error") {
          this.uploadError = res.message;
        } else {
          this.messageService.add({
            key: "myKey1",
            severity: "success",
            summary: "Informazioni",
            detail: "Saved successfully",
          });

          this.ngOnInit();
        }
      },
      (error) => (this.error = error),
    );
  }

  private mapSkillsForPdf() {
    const skills = this.form.get("skills")?.value || [];

    return skills.map((s: any, i: number) => {
      const d = s.description;
      const price = Number(s.price || 0);
      if (d && typeof d === "object") {
        return { index: i + 1, title: this.bookingTitle(d), details: this.bookingMeta(d), qty: 1, unit: price, price };
      }
      const qty = Number(s.qty ?? 1) || 1;
      return { index: i + 1, title: String(d || "-"), details: "", qty, unit: Number(s.unit ?? price / qty), price };
    });
  }

  initSkill(): FormArray {
    return this.fb.array<FormGroup>([]);
  }

  isBookingLine(ctrl: AbstractControl): boolean {
    const d = ctrl.get("description")?.value;
    return !!d && typeof d === "object";
  }

  private fmtDay(v: any): string {
    return v ? String(v).slice(0, 10).split("-").reverse().join("/") : "";
  }

  bookingTitle(d: any): string {
    return d?.room?.title || "Prenotazione";
  }

  bookingMeta(d: any): string {
    const nights = Number(d?.nights ?? 0);
    const guest = d?.client ? `${d.client.name ?? ""} ${d.client.surname ?? ""}`.trim() : `${d?.name ?? ""} ${d?.surname ?? ""}`.trim();
    return [
      `${this.fmtDay(d?.date_from)} – ${this.fmtDay(d?.date_to)}`,
      nights ? `${nights} ${nights === 1 ? "notte" : "notti"}` : "",
      guest,
    ].filter(Boolean).join(" · ");
  }

  bookingPriceNote(ctrl: AbstractControl): string {
    const d = ctrl.get("description")?.value;
    const total = Number(d?.final_price);
    const price = Number(ctrl.get("price")?.value ?? 0);
    if (!d || isNaN(total) || Math.abs(total - price) < 0.005) return "";
    return `Totale prenotazione ${total.toLocaleString("it-IT", { style: "currency", currency: "EUR" })}`;
  }

  private bookingRow(booking: any, price: number): FormGroup {
    const row = this.fb.group({
      description: [booking],
      price: [price, [Validators.required]],
      itemTotal: [{ value: price, disabled: true }],
    });
    row.get("price")?.valueChanges.subscribe((v) => {
      row.get("itemTotal")?.setValue(Number(v || 0), { emitEvent: false });
      this.itemsChanged();
    });
    return row;
  }

  private serviceRow(text: string, qty: number, unit: number): FormGroup {
    const total = qty * unit;
    const row = this.fb.group({
      description: [text, Validators.required],
      qty: [qty],
      unit: [unit],
      price: [total],
      itemTotal: [{ value: total, disabled: true }],
    });
    const recalc = () => {
      const t = Number(row.get("qty")?.value || 0) * Number(row.get("unit")?.value || 0);
      row.get("price")?.setValue(t, { emitEvent: false });
      row.get("itemTotal")?.setValue(t, { emitEvent: false });
      this.itemsChanged();
    };
    row.get("qty")?.valueChanges.subscribe(recalc);
    row.get("unit")?.valueChanges.subscribe(recalc);
    return row;
  }

  private setSkillsFormArray(raw: any) {
    const fa = this.form.get("skills") as FormArray;
    if (!fa) return;

    const items = this.parseSkills(raw);

    fa.clear();
    this.skillsValues.set(items);

    items.forEach((e) => {
      const price = Number(e?.price ?? 0);
      const d = e?.description;
      if (d && typeof d === "object") {
        fa.push(this.bookingRow(d, price));
      } else if (e?.unit !== undefined && e?.unit !== null) {
        // saved by this page: quantity, unit price, and the line total in "price"
        fa.push(this.serviceRow(d ?? "", Number(e.qty ?? 1) || 1, Number(e.unit)));
      } else if (e?.qty !== undefined && e?.qty !== null && e?.qty !== "") {
        // older invoices and the quotes/orders pages: "price" is the price of ONE unit, the line is qty x price
        fa.push(this.serviceRow(d ?? "", Number(e.qty) || 1, price));
      } else {
        // a line with only an amount
        fa.push(this.serviceRow(d ?? "", 1, price));
      }
    });

    this.itemsChanged();
  }

  readonly servicePresets = ["Colazione", "Tassa di soggiorno", "Parcheggio", "Animali domestici", "Extra", "Sconto"];

  addService(text = ""): void {
    this.skills.push(this.serviceRow(text, 1, 0));
    this.itemsChanged();
  }

  private createSkillFormGroup(skill: any): FormGroup {
    return new FormGroup({
      description: new FormControl(skill.description),
      qty: new FormControl(skill.qty),
      price: new FormControl(skill.price),
      itemTotal: new FormControl(skill.itemTotal),
    });
  }

  public addSkill(skill: any) {
    this.skills.push(this.createSkillFormGroup(skill));
  }

  get skills() {
    return this.form.get("skills") as FormArray;
  }

  addQuantity() {
    this.addService("");
  }

  removeQuantity(i: number): void {
    (this.form.get("skills") as FormArray).removeAt(i);
    this.itemsChanged();
  }

  private parseSkills(raw: any): any[] {
    if (!raw) return [];

    if (Array.isArray(raw)) return raw;

    if (typeof raw === "string") {
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }

    if (typeof raw === "object") return Object.values(raw);

    return [];
  }

  onSubmit() {
    this.itemsChanged();

    this.form.patchValue({
      subtotal: this.subTotal(),
      vat: this.vat(),
      total: this.grandTotal(),
    });

    super.onSubmit();
  }

  searchClient(event: { query: string }) {
    const query = (event.query || "").trim();

    if (!query || query.length < 2) {
      this.filteredClients.set([]);
      return;
    }

    const paramsRequests = { _start: 1, _limit: 10, name: query };

    this.clientsService.search(paramsRequests).subscribe((pData) => {
      this.filteredClients.set((pData || []).map((c) => withClientLabel(c)) as any[]);
    });
  }

  onClientClear() {
    this.selectedClient.set(null);
    this.selectedClientData.set(null);
    this.form.get("client_id")?.setValue(null);
  }

  onClientSelect(e: any) {
    const client: Clients = e.value ?? e;

    this.selectedClient.set(withClientLabel(client));
    this.selectedClientData.set(client);

    this.form.get("client_id")?.setValue(client.id);
    this.loadClientBookings(client.id);
  }

  readonly clientBookings = signal<any[]>([]);

  loadClientBookings(clientId?: string): void {
    const id = clientId || this.form.get("client_id")?.value;
    if (!id) {
      this.clientBookings.set([]);
      return;
    }
    this.bookingsService
      .list({ client_id: id, _start: 1, _limit: 100, _sort: "date_from", _order: "desc" })
      .subscribe({
        next: (data) => this.clientBookings.set(Array.isArray(data) ? data : []),
        error: () => this.clientBookings.set([]),
      });
  }

  isAdded(booking: any): boolean {
    return this.skills.controls.some((c) => c.get("description")?.value?.id === booking.id);
  }

  addBooking(booking: any): void {
    if (this.isAdded(booking)) return;
    this.skills.push(this.bookingRow(booking, Number(booking.final_price ?? 0)));
    this.itemsChanged();
  }

  addAllBookings(): void {
    this.clientBookings().forEach((b) => this.addBooking(b));
  }
}
